import { Container, ListItemButton, ListItemText } from "@mui/material";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { setBreadcumbs, setIsShowBack, setTitle } from "../../../containers/containers.reducer";
import checkAccess from "../../../shared/checkAccess";
import CustomModal from "../../../shared/CustomModal";
import CustomTable from "../../../shared/CustomTable";
import notificationError from "../../../shared/notificationError";
import notificationSuccess from "../../../shared/notificationSuccess";
import { deleteOvertime } from "../../absent/overtime/overtime.api";
import ReportOvertimeEdit from "./ReportOvertimeEdit";

export default function ReportOvertime() {

    const dispatch = useDispatch()

    const [dataSelected, setDataSelected] = useState<any>({})
    const [modalEdit, setModalEdit] = useState(false)
    const [timeGetData, setTimeGetData] = useState<any>(undefined)

    useEffect(() => {
        dispatch(setTitle("Report"))
        dispatch(setIsShowBack(false))
        dispatch(setBreadcumbs([
            {
                name: "Report",
                url: ""
            },
            {
                name: "Overtime Report",
                url: "/report/overtime"
            }
        ]))
    }, [])

    const handleCloseModalEdit = (isReload: boolean) => {
        setModalEdit(false)
        if (isReload) {
            setTimeGetData(new Date().getTime())
        }
    }

    const handleDelete = (id: string) => {
        Swal.fire({
            icon: "question",
            title: "Are you sure to delete this data?",
            showCancelButton: true
        })
            .then(response => {
                if (response.isConfirmed) {
                    dispatch<any>(deleteOvertime(id))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                notificationSuccess("success delete overtime")
                                setTimeGetData(new Date().getTime())
                            }
                            else {
                                notificationError(response)
                            }
                        })
                }
            })
    }

    return (
        <Container maxWidth='xl'>
            <CustomModal
                open={modalEdit}
                onClose={handleCloseModalEdit}
                title="Edit Overtime"
                component={
                    <ReportOvertimeEdit onClose={handleCloseModalEdit} data={dataSelected} />
                }
            />
            <CustomTable
                url={"/report/overtime"}
                filterDate={true}
                columns={[
                    {
                        name: "Employee",
                        key: "employee_name",
                        sum: (props: any) => {
                            return 1
                        }
                    },
                    {
                        name: "Team",
                        key: "employee_team_names",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <p>
                                    {props.data.employee_team_names && props.data.employee_team_names.replaceAll(',', ', ')}
                                    </p>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Head",
                        key: "head_name"
                    },
                    {
                        name: "HR",
                        key: "hr_name"
                    },
                    {
                        name: "Overtime Date",
                        key: "name",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <span>
                                        {props.data.name ? moment(props.data.name).format('DD-MM-YYYY') : '-'}
                                    </span>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Request Minutes",
                        key: "minutes",
                        sum: (props: any) => {
                            return props.data.minutes
                        }
                    },
                    {
                        name: "Notes",
                        key: "notes"
                    },
                    {
                        name: "Status",
                        key: "status_name"
                    },
                    {
                        name: "Approved Minutes",
                        key: "minutes_approval",
                        sum: (props: any) => {
                            return props.data.minutes_approval
                        }
                    },
                    {
                        name: "Multiple",
                        key: "multiple"
                    },
                    {
                        name: "Rejection Notes",
                        key: "notes_approval"
                    },
                    {
                        name: "Total Minutes",
                        key: "minutes_total",
                        sum: (props: any) => {
                            return props.data.minutes_total
                        },
                        sumCustomRender: (props: any) => {
                            return (
                                <td>
                                    <b>
                                        {props.data.minutes_total} / {(props.data.minutes_total / 60).toFixed(2)} Hours
                                    </b>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Job",
                        key: "job_list",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    {props.data.job_list
                                        ? <ul>
                                            {JSON.parse(props.data.job_list).map((job: any) => (
                                                <li>
                                                    {job.jobnumber_number_job} - ({job.quantity_pole})
                                                </li>
                                            ))}
                                        </ul>
                                        : '-'
                                    }
                                </td>
                            )
                        }
                    }
                ]}
                export={true}
                rowActions={(props: any) => (
                    <Fragment>
                        {checkAccess("EDIT") &&
                            <ListItemButton onClick={() => { setDataSelected(props.data); setModalEdit(true) }}>
                                <ListItemText>Edit</ListItemText>
                            </ListItemButton>
                        }
                        {checkAccess("DELETE") &&
                            <ListItemButton onClick={() => handleDelete(props.data.id)}>
                                <ListItemText>Delete</ListItemText>
                            </ListItemButton>
                        }
                    </Fragment>
                )}
                timeGetData={timeGetData}
            />
        </Container>
    )
}